class FormWithPasswordConfirmation {
	#form;
	#passwordInput;
	
	constructor(form) {
		this.#form = form;
		
		/** @type {HTMLInputElement} */
		this.#passwordInput = this.getElement('.passwordInput');
		
		this.#initEvents();
	}
	
	#initEvents() {
		const confirmPasswordInput = this.getElement('.confirmPasswordInput');
		
		this.getElement('.toggleConfirmPassword').addEventListener(
			'click',
			() => {
				this.togglePasswordInputType(confirmPasswordInput);
				this.updateToggleButtonTexts(confirmPasswordInput.parentElement.querySelector('.showText'), confirmPasswordInput.parentElement.querySelector('.hideText'));
			}
		);
		this.#passwordInput.addEventListener('input', this.#checkMatchingPassword.bind(this));
		
		confirmPasswordInput.addEventListener(
			'change',
			() => {
				this.#checkMatchingPassword();
				confirmPasswordInput.addEventListener('input', () => {
					this.#checkMatchingPassword();
				});
			},
			{
				'once': true
			}
		);
		
		if (confirmPasswordInput.value) {
			this.#checkMatchingPassword();
		}
	}
	
	#checkMatchingPassword() {
		const confirmPasswordInput = this.getElement('.confirmPasswordInput'),
		      infoClassList        = this.getElement('.passwordMismatchInfo').classList;
		
		// don't push the user if the confirmPasswordInput is still empty
		if (!confirmPasswordInput.value) {
			infoClassList.add('hidden-element');
			
			return;
		}

		if (this.doPasswordsMatch()) {
			this.getElement('.passwordMismatchInfo').style.display = 'none';
			confirmPasswordInput.classList.remove('invalid');
			confirmPasswordInput.parentElement.classList.remove('invalid');
		} else {
			this.getElement('.passwordMismatchInfo').style.display = 'block';
			confirmPasswordInput.classList.add('invalid');
			confirmPasswordInput.parentElement.classList.add('invalid');
		}
	}
	
	doPasswordsMatch() {
		const confirmPasswordInput = this.getElement('.confirmPasswordInput');

		return this.#passwordInput.value === confirmPasswordInput.value;
	}

	togglePasswordInputType(passwordInputTarget) {
		passwordInputTarget.type = passwordInputTarget.type === 'password'
			? 'text'
			: 'password';
	}
	
	updateToggleButtonTexts(passwordShow, passwordHide) {
		passwordShow.style.display = passwordShow.style.display === 'none'
			? 'block'
			: 'none';
		passwordHide.style.display = passwordHide.style.display === 'block'
			? 'none'
			: 'block';
	}
	
	/**
	 * @param {string} selector
	 * @returns {Element | HTMLInputElement}
	 */
	getElement(selector) {
		return this.#form.querySelector(selector);
	}
}

export default FormWithPasswordConfirmation;